import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Button } from './ui/button';
import { ArrowRight, Check, X, ShieldCheck, ShieldOff } from 'lucide-react';

const comparisonData = [
  { feature: 'Nationwide legal protection', registered: true, unregistered: false },
  { feature: 'Use of registered symbol', registered: true, unregistered: false },
  { feature: 'Listed in USPTO database', registered: true, unregistered: false },
  { feature: 'Access to federal courts', registered: true, unregistered: false },
  { feature: 'Presumption of ownership', registered: true, unregistered: false },
  { feature: 'E-commerce brand programs', registered: true, unregistered: false },
  { feature: 'Deterrent against infringers', registered: true, unregistered: false },
  { feature: 'Brand value as IP asset', registered: true, unregistered: false },
  { feature: 'Common law rights only', registered: false, unregistered: true },
  { feature: 'Limited to local area', registered: false, unregistered: true },
];

const ComparisonSection = ({ onOpenContactForm }) => {
  const section = useScrollAnimation({ threshold: 0.1 });
  const header = useScrollAnimation({ threshold: 0.15 });
  return (
    <section data-testid="comparison-section" className="py-24 md:py-32 bg-[#041B1C] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-16 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="inline-block bg-[#A5BF23]/10 text-[#A5BF23] px-4 py-1.5 rounded-full text-xs font-bold tracking-[0.2em] mb-4">COMPARE</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F0F4F4] mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Registered Brand Name vs. Unregistered</h2>
          <p className="text-base text-[#A0B2B2] leading-relaxed">The gap between a registered and unregistered brand name is massive. It is the difference between owning your name and hoping no one takes it.</p>
        </div>
        <div ref={section.ref} className={`max-w-3xl mx-auto scroll-fade-up scroll-delay-2 ${section.isVisible ? 'scroll-visible' : ''}`}>
          <div className="bg-[#093336]/60 backdrop-blur-sm border border-white/5 rounded-2xl overflow-hidden">
            <div className="grid grid-cols-[1fr_110px_110px] sm:grid-cols-[1fr_140px_140px]">
              <div className="p-5 bg-[#093336] border-b border-white/5"><span className="text-sm font-bold text-[#F0F4F4]">Feature</span></div>
              <div className="p-5 bg-[#A5BF23]/5 border-b border-white/5 text-center">
                <div className="flex flex-col items-center gap-1"><ShieldCheck className="w-5 h-5 text-[#A5BF23]" strokeWidth={1.5} /><span className="text-xs font-bold text-[#A5BF23]">Registered</span></div>
              </div>
              <div className="p-5 bg-[#093336] border-b border-white/5 text-center">
                <div className="flex flex-col items-center gap-1"><ShieldOff className="w-5 h-5 text-[#A0B2B2]/50" strokeWidth={1.5} /><span className="text-xs font-bold text-[#A0B2B2]/50">Unregistered</span></div>
              </div>
              {comparisonData.map((row, i) => (
                <React.Fragment key={i}>
                  <div className={`px-5 py-3.5 text-sm text-[#A0B2B2] border-b border-white/5 ${i % 2 === 0 ? '' : 'bg-white/[0.02]'}`}>{row.feature}</div>
                  <div className={`px-5 py-3.5 flex justify-center border-b border-white/5 ${i % 2 === 0 ? '' : 'bg-white/[0.02]'}`}>
                    {row.registered ? <div className="w-6 h-6 rounded-full bg-[#A5BF23]/10 flex items-center justify-center"><Check className="w-3.5 h-3.5 text-[#A5BF23]" /></div> : <div className="w-6 h-6 rounded-full bg-red-500/10 flex items-center justify-center"><X className="w-3.5 h-3.5 text-red-400" /></div>}
                  </div>
                  <div className={`px-5 py-3.5 flex justify-center border-b border-white/5 ${i % 2 === 0 ? '' : 'bg-white/[0.02]'}`}>
                    {row.unregistered ? <div className="w-6 h-6 rounded-full bg-amber-500/10 flex items-center justify-center"><Check className="w-3.5 h-3.5 text-amber-400" /></div> : <div className="w-6 h-6 rounded-full bg-red-500/10 flex items-center justify-center"><X className="w-3.5 h-3.5 text-red-400" /></div>}
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="text-center mt-10">
            <Button data-testid="comparison-cta" onClick={onOpenContactForm}
              className="bg-[#A5BF23] hover:bg-[#8A9F1D] text-[#041B1C] font-semibold px-10 h-12 rounded-full transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(165,191,35,0.3)]">
              Register Your Brand Name Now <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
